import { Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import './StoreCheckbox.scss';

type Props = {
    rtl: boolean;
    handleCheckedChange: any;
    checked: any;
}

function StoreCheckbox({ rtl, checked, handleCheckedChange }: Props) {
    const { t } = useTranslation();

    return (
        <div className="store_locator_checkbox" style={{ direction: rtl ? 'rtl' : 'ltr' }}>

            <Typography rtl={rtl} className='store_Checkbox'>
                <label className="checkbox_label">
                    <input
                        type="checkbox"
                        checked={checked.openNow}
                        onChange={() => handleCheckedChange("openNow")}
                        style={!rtl ? { marginRight: '18px' } : { marginLeft: '18px' }}
                    />
                    <span className="open">{t('Open_now')}</span>
                </label>
            </Typography>
            <Typography rtl={rtl} className='store_Checkbox'>
                <label className="checkbox_label">
                    <input
                        type="checkbox"
                        checked={checked.selfService}
                        onChange={() => handleCheckedChange("selfService")}
                        style={!rtl ? { marginRight: '18px' } : { marginLeft: '18px' }}
                    />
                    <span className="open">{t('self_service_kiosk')}</span>
                </label>
            </Typography>
            <Typography rtl={rtl} className='store_Checkbox'>
                <label className="checkbox_label">
                    <input
                        type="checkbox"
                        checked={checked.disabilityFriendly}
                        onChange={() => handleCheckedChange("disabilityFriendly")}
                        style={!rtl ? { marginRight: '18px' } : { marginLeft: '18px' }}
                    />
                    <span className="open">{t('disability_friendly')}</span>
                </label>
            </Typography>

        </div>
    );
}

export default StoreCheckbox